import { render, staticRenderFns } from "./QuestionScreen.vue?vue&type=template&id=7175eec8&scoped=true&"
import script from "./QuestionScreen.vue?vue&type=script&lang=js&"
export * from "./QuestionScreen.vue?vue&type=script&lang=js&"
import style0 from "./QuestionScreen.vue?vue&type=style&index=0&id=7175eec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175eec8",
  null
  
)

export default component.exports